(function ($, undefined) {
  // -------- ##### FILTER MAIN CLASS ##### ----------------

  function Filter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;

    this.FILTER_CELL_CLASS = "query-filter__cell";
  }
  window.EasyQueryFilter = Filter;
  Filter.prototype.typesWithoutOperator = ["date_period", "query_string"];

  // ---- should be overwritten ----
  Filter.prototype.createInput = function (wrapingEl) {
    this.input = this.create_text_input(this.name, this.inputSize);
    wrapingEl.append(this.input);
  };
  Filter.prototype.isActive = function () {
    return this.check_box.is(":checked");
  };

  Filter.prototype.setValue = function (values) {
    this.input.val(values);
  };
  Filter.prototype.getValue = function () {
    return this.input.val();
  };

  // --------------- HELPERS ---------------
  Filter.prototype.getPrefixedHtmlName = function (name, suffix) {
    return this.filters.options.blockName ? this.filters.options.blockName + "[" + name + "]" + suffix : name + suffix;
  };

  Filter.prototype.wrapId = function (id) {
    return this.filters.options.modulUniqId + id + this.name.replace(/\./g, "_");
  };

  Filter.prototype.wrapClass = function (cls) {
    return cls + "_" + this.name.replace(/\./g, "_");
  };

  Filter.prototype.create_text_input = function (name, size) {
    return $("<input>", {
      type: "text",
      name: this.getPrefixedHtmlName("values", "[" + name + "][]"),
      id: this.wrapId("values_"),
      class: this.wrapClass("values"),
      "data-cy": `input__${this.wrapId("values_")}--query-filters`,
    }).attr("size", size);
  };

  Filter.prototype.create_time_input = function (name, size) {
    return $("<input>", {
      type: "time",
      name: this.getPrefixedHtmlName("values", "[" + name + "][]"),
      id: this.wrapId("values_"),
      class: this.wrapClass("values"),
      "data-cy": `input__${this.wrapId("values_")}--query-filters`,
    }).attr("size", size);
  };

  // ----------------- DOM HELPERS ---------------------

  Filter.prototype.enableValues = function (indexes) {
    var values = this.valueInput.find(this.wrapClass(".values"));
    var isAutocomplete = this.valueInput.find(".easy-multiselect-tag-container").length > 0;

    for (var i = 0; i < values.length; ++i) {
      var value = values.eq(i);
      if (indexes.indexOf(i) !== -1) {
        value.prop("disabled", false);
        var parent = value.parent("span").show();
        if (isAutocomplete) {
          parent.find("input[type='hidden']").prop("disabled", false);
        }
      } else {
        value.prop("disabled", true).val("");
        var parent = value.parent("span").hide();
        if (isAutocomplete) {
          parent.find("input[type='hidden']").prop("disabled", true);
        }
      }
    }
    this.valueInput.toggle(indexes.length > 0);
  };

  Filter.prototype.toggle_operator = function (operator) {
    if (typeof operator === "undefined" || !operator) {
      this.valueInput.show();
    } else {
      switch (operator) {
        case "!*":
        case "*":
        case "t":
        case "ld":
        case "w":
        case "lw":
        case "l2w":
        case "m":
        case "lm":
        case "y":
        case "o":
        case "*o":
        case "!o":
        case "c":
        case ">dd":
          this.enableValues([]);
          break;
        case "><":
          this.enableValues([0, 1]);
          break;
        case "<t+":
        case ">t+":
        case "><t+":
        case "t+":
        case ">t-":
        case "<t-":
        case "><t-":
        case "t-":
          this.enableValues([2]);
          break;
        case "=p":
        case "=!p":
        case "!p":
          this.enableValues([1]);
          break;
        default:
          this.enableValues([0]);
          break;
      }
    }
  };

  // -------------- ELEMENT CREATION -----------

  Filter.prototype.createValueInput = function (operator) {
    var $span = $("<span>", { class: this.wrapClass("span_values") });

    this.valueInput = $("<div>", { id: this.wrapId("div_values_") }).append($span);
    $(".values", this.element).append(this.valueInput);

    this.createInput($span, operator);

    return this.valueInput;
  };

  Filter.prototype.createFilter = function (selected) {
    var that = this,
      available_operators = this.filters.available_operators[this.type],
      chck_id = this.wrapId("cb_"),
      opselect_name = this.getPrefixedHtmlName("operators", "[" + this.name + "]"),
      operator = typeof selected === "undefined" ? null : selected["operator"];

    this.values = typeof selected === "undefined" ? null : selected["values"];
    this.check_box = $("<input>", {
      type: "checkbox",
      name: this.getPrefixedHtmlName("fields", "[]"),
      value: this.name,
      checked: true,
      id: chck_id,
      "data-cy": `input__${chck_id}--query-filters`,
    });
    //:onclick => "EASY.query.toggleFilter('#{field_dom_id}', '#{modul_uniq_id}');", :id => "#{modul_uniq_id}cb_#{field_dom_id}"
    this.chck_label = $("<label>", { for: chck_id }).text(this.label).prepend(this.check_box);

    this.element = $("<div></div>").append($("<div>", { class: "field" }).append(this.chck_label));

    if (this.typesWithoutOperator.indexOf(this.type) !== -1) {
      this.element.append($("<div>", { colspan: 2, class: `values ${that.FILTER_CELL_CLASS}` }));
    } else {
      if (available_operators.length > 1) {
        this.operator_select = $("<select>", {
          name: opselect_name,
          id: this.wrapId("operators_"),
          "data-cy": `select--${this.wrapId("operators_")}--query-filters`,
        });
        for (var i = 0; i < available_operators.length; ++i) {
          this.operator_select.append(
            $("<option>", {
              value: available_operators[i],
              selected: operator == available_operators[i],
              class: "block",
            }).text(this.filters.options.i18n.operators[available_operators[i]])
          );
        }
        this.operator_select.on("change", function (evt) {
          that.toggle_operator($(this).val());
        });
      } else {
        this.operator_select = $("<input>", { type: "hidden", name: opselect_name, value: available_operators[0] });
      }

      this.element.append($("<div>", { class: `operator ${that.FILTER_CELL_CLASS}` }).append(this.operator_select));
      this.element.append($("<div>", { class: `values ${that.FILTER_CELL_CLASS}` }));
    }

    this.filters.getFiltersTable(this.name).prepend(this.element);

    this.createValueInput(operator);
    if (this.operator_select) this.toggle_operator(this.operator_select.val());

    if (this.values) this.setValue(this.values);

    return this.element;
  };

  Filter.prototype.getUrlValue = function () {
    var val = this.getValue(),
      op = "";

    if (this.operator_select) {
      op = this.operator_select.val();
    }
    return op + (Array.isArray(val) ? val.join("|") : val.toString());
  };

  // -------------- ##### FILTER TYPES ##### ------------------

  function DatePeriodFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
    this.afterPeriodLoad = [];
  }
  DatePeriodFilter.prototype = new Filter();
  DatePeriodFilter.prototype.constructor = DatePeriodFilter;
  DatePeriodFilter.prototype.parent = Filter.prototype;
  DatePeriodFilter.prototype.createInput = function (wrapingEl, operator) {
    var that = this,
      $period1_container = $('<div class="filters__settings-due-date">'),
      $period2_container = $('<div class="filters__settings-due-date">'),
      $period2_inner_container,
      $period2_radio,
      $period2_timerange,
      $period2_from,
      $period2_to;

    var values = {};

    this.input = [];
    this.input.push({});
    this.input.push({});

    wrapingEl.append($period1_container);
    wrapingEl.append($period2_container);

    this.input[0]["radio"] = $("<input>", {
      type: "radio",
      name: this.getPrefixedHtmlName("operators", "[" + this.name + "]"),
      value: "date_period_1",
      checked: operator != "date_period_2",
      id: this.wrapId("") + "_date_period_1",
      "data-cy": `input__${this.wrapId("")}_date_period_1--query-filters`,
    });
    this.input[0]["select"] = $("<select>", {
      name: this.getPrefixedHtmlName("values", "[" + this.name + "][period]"),
      id: this.wrapId("values_") + "_period",
      "data-cy": `select--${this.wrapId("values_")}_period--query-filters`,
    });
    this.input[0]["n_days"] = $("<input>", {
      type: "text",
      name: this.getPrefixedHtmlName("values", "[" + this.name + "][period_days]"),
      id: this.wrapId("values_") + "_period_days",
      class: this.wrapClass("values"),
      "data-cy": `input__${this.wrapId("values_")}_period_days--query-filters`,
    }).attr("size", 3);
    this.input[0]["m_days"] = $("<input>", {
      type: "text",
      name: this.getPrefixedHtmlName("values", "[" + this.name + "][period_days2]"),
      id: this.wrapId("values_") + "_period_days",
      class: this.wrapClass("values"),
      "data-cy": `input__${this.wrapId("values_")}_period_days--query-filters`,
    }).attr("size", 3);
    this.ndays_container = $("<span>", {
      id: this.wrapId("values_") + "_period_days_container",
      class: "values-period-days-container",
    })
      .append(this.input[0]["m_days"].hide())
      .append(this.input[0]["n_days"])
      .append(
        $("<span>", {
          id: this.wrapId("values") + "_period_days_description_container",
          class: "help",
          style: "margin-left: 27px;",
        })
      );

    $period1_container.append(this.input[0]["radio"]);
    $period1_container.append(this.input[0]["select"]);
    $period1_container.append(this.ndays_container);

    $.ajax(this.filters.options.listValuesUrl, {
      method: "POST",
      data: $.extend(JSON.parse(this.filters.options.listValuesParams), { filter_name: this.name }),
      success: function (data) {
        that.input[0]["select"].on("change", function (evt) {
          var option = $(this).find("option:selected");
          if (option.length > 0 && option.val().indexOf("n_days") !== -1) {
            that.ndays_container.show();
            $(".help", that.ndays_container).html("<em>" + option.data("description") + "</em>");
            that.toggleNdaysContainer(option.val());
          } else {
            that.ndays_container.hide();
          }
        });
        that.input[0]["select"].html(data);
        for (var i = 0; i < that.afterPeriodLoad.length; ++i) {
          that.afterPeriodLoad[i].call(that);
          that.afterPeriodLoad = [];
        }
        that.input[0]["select"].change(); //fill it in - if selected ndays
      },
    });

    this.input[0]["select"].on("focus", function (evt) {
      that.input[0]["radio"].prop("checked", true);
    });

    this.input[1]["radio"] = $("<input>", {
      type: "radio",
      name: this.getPrefixedHtmlName("operators", "[" + this.name + "]"),
      value: "date_period_2",
      checked: operator == "date_period_2",
      id: this.wrapId("") + "_date_period_2",
      "data-cy": `input__${this.wrapId("")}_date_period_2--query-filters`,
    });
    $period2_timerange = $('<span class="input--range">').on("click", function (evt) {
      that.input[1]["radio"].prop("checked", true);
    });
    this.input[1]["from"] = $("<input>", {
      type: "text",
      name: this.getPrefixedHtmlName("values", "[" + this.name + "][from]"),
      id: this.wrapId("") + "_from",
      "data-cy": `input__${this.wrapId("")}_from--query-filters`,
    }).attr("size", 10);
    this.input[1]["to"] = $("<input>", {
      type: "text",
      name: this.getPrefixedHtmlName("values", "[" + this.name + "][to]"),
      id: this.wrapId("") + "_to",
      "data-cy": `input__${this.wrapId("")}_to--query-filters`,
    }).attr("size", 10);
    var $from = $('<span class="input-append">');
    $from.append($("<span>").append(document.createTextNode(this.filters.options.i18n.label_date_from)));
    $from.append(this.input[1]["from"]);
    $period2_timerange.append($from);
    var $to = $('<span class="input-append">');
    $to.append($("<span>").append(document.createTextNode(this.filters.options.i18n.label_date_to)));
    $to.append(this.input[1]["to"]);
    $period2_timerange.append($to);
    $("input", $period2_timerange)
      .on("change", function (evt) {
        $(this).closest("span").click();
      })
      .datepicker(EASY.datepickerOptions);
    $period2_container.append(this.input[1]["radio"]);
    $period2_container.append($period2_timerange);
  };
  DatePeriodFilter.prototype.toggleNdaysContainer = function (period_type) {
    if (period_type.indexOf("m_to_n") !== -1) {
      this.input[0]["m_days"].show();
    } else {
      this.input[0]["m_days"].hide();
    }
  };
  DatePeriodFilter.prototype.setOperator = function (operator) {
    this.operator_select = this.input[operator == "date_period_2" ? 1 : 0]["radio"].prop("checked", true);
  };
  DatePeriodFilter.prototype.getOperator = function () {
    return this.input[1]["radio"].is(":checked") ? "date_period_2" : "date_period_1";
  };
  DatePeriodFilter.prototype.afterPeriodLoaded = function (callback) {
    if (this.periodLoaded) {
      callback.call(this);
    } else {
      this.afterPeriodLoad.push(callback);
    }
  };
  DatePeriodFilter.prototype.setValue = function (values) {
    if (!(values["period"] && values["period"].indexOf("n_days") !== -1)) {
      this.ndays_container.hide();
    } else if (values["period"].indexOf("m_to_n") === -1) {
      this.ndays_container.show();
      this.input[0]["n_days"].val(values["period_days"]);
      this.toggleNdaysContainer(values["period"]);
    } else {
      this.ndays_container.show();
      this.input[0]["m_days"].val(values["period_days2"]);
      this.input[0]["n_days"].val(values["period_days"]);
    }

    this.afterPeriodLoaded(function () {
      $('option[value="' + values["period"] + '"]', this.input[0]["select"]).prop("selected", true);
    });
    this.input[1]["from"].val(values["from"]);
    this.input[1]["to"].val(values["to"]);
  };
  DatePeriodFilter.prototype.getValue = function () {
    var result = {};
    result["period"] = this.input[0]["select"].val();
    if (result["period"].indexOf("n_days") !== -1) {
      if (result["period"].indexOf("m_to_n") !== -1) {
        result["period_days2"] = this.input[0]["m_days"].val();
        result["period_days"] = this.input[0]["n_days"].val();
      } else {
        result["period_days"] = this.input[0]["n_days"].val();
      }
    }
    result["from"] = this.input[1]["from"].val();
    result["to"] = this.input[1]["to"].val();
    return result;
  };
  DatePeriodFilter.prototype.getUrlValue = function () {
    var res = [],
      val = this.getValue();
    if (this.getOperator() == "date_period_1") {
      res.push(val["period"]);
      if (val["period_days2"] && val["period_days"]) {
        res.push(val["period_days2"]);
        res.push(val["period_days"]);
      } else if (val["period_days"]) {
        res.push(val["period_days"]);
      }
    } else {
      res.push(val["from"]);
      res.push(val["to"]);
    }
    return res.join("|");
  };

  function BooleanFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  BooleanFilter.prototype = new Filter();
  BooleanFilter.prototype.constructor = BooleanFilter;
  BooleanFilter.prototype.createInput = function (wrapingEl) {
    var $label, suffix;

    this.input = {};

    for (var i = 1; i >= 0; --i) {
      suffix = i ? "_true" : "_false";
      this.input[i] = $("<input>", {
        type: "radio",
        value: i,
        name: this.getPrefixedHtmlName("values", "[" + this.name + "][]"),
        checked: i == 1,
        id: this.wrapId("values_") + suffix,
        "data-cy": `input__${this.wrapId("values_")}${suffix}--query-filters`,
      });
      $label = $("<label>", { for: this.wrapId("values_") + suffix }).text(this.filters.options.i18n[i ? "yes" : "no"]);
      wrapingEl.append($("<span>").append(this.input[i]).append($label));
    }
  };
  BooleanFilter.prototype.setValue = function (values) {
    var value = Array.isArray(values) ? values[0] : values;
    if (value == "0" || value == "false" || !value) {
      this.input[0].prop("checked", true);
    } else {
      this.input[1].prop("checked", true);
    }
  };
  BooleanFilter.prototype.getValue = function () {
    return this.input[0].is(":checked") ? 0 : 1;
  };

  function ListFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  ListFilter.prototype = new Filter();
  ListFilter.prototype.constructor = ListFilter;
  ListFilter.prototype.setMultiselectOptions = function (source) {
    this.multiselect_options = {
      source: source,
      selected: null,
      multiple: this.filters.options.listMultiple,
      select_first_value:
        this.values == null || this.values.length == 0 ? this.filters.options.selectListFirstValue : false,
      load_immediately: this.filters.options.loadListValuesImmediately,
    };
  };
  ListFilter.prototype.createInput = function (wrapingEl) {
    var that = this;
    this.setMultiselectOptions(function (callback) {
      that.filters.loadPossibleValues(that.name, callback);
    });
    this.createAutocomplete(wrapingEl);
  };
  ListFilter.prototype.getAutocompleteInputName = function () {
    var core_name = "[" + this.name + "]";
    if (this.multiselect_options["multiple"]) {
      core_name += "[]";
    }
    return this.getPrefixedHtmlName("values", core_name);
  };
  ListFilter.prototype.createAutocomplete = function (wrapingEl) {
    this.input = $("<input>", {
      type: "text",
      name: this.getAutocompleteInputName(),
      class: this.wrapClass("values"),
      id: this.wrapId(""),
      "data-cy": `input__${this.wrapId("")}--query-filters`,
    });

    wrapingEl.append($("<span>", { class: "easy-multiselect-tag-container" }).append(this.input));

    this.input.easymultiselect(this.multiselect_options);
    return this.input;
  };
  ListFilter.prototype.setValue = function (values) {
    this.input.easymultiselect("setValue", values);
  };
  ListFilter.prototype.getValue = function () {
    return this.input.easymultiselect("getValue");
  };

  function AutocompleteFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  AutocompleteFilter.prototype = new ListFilter();
  AutocompleteFilter.prototype.constructor = AutocompleteFilter;
  AutocompleteFilter.prototype.parent = ListFilter.prototype;
  AutocompleteFilter.prototype.createInput = function (wrapingEl) {
    var source_options;
    if (this.filters.options.autocompleteSources && this.filters.options.autocompleteSources[this.name]) {
      source_options = this.filters.options.autocompleteSources[this.name];
    } else {
      source_options = { url: window.urlPrefix + "/easy_autocompletes/query_entities", root: "entities" };
    }

    this.setMultiselectOptions(source_options["url"]);
    this.multiselect_options["multiple"] = this.filters.options.listMultiple;
    this.multiselect_options["preload"] = false;
    this.multiselect_options["rootElement"] = source_options["root"];
    this.createAutocomplete(wrapingEl);
  };

  function RelationFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  RelationFilter.prototype = new AutocompleteFilter();
  RelationFilter.prototype.constructor = RelationFilter;
  RelationFilter.prototype.parent = AutocompleteFilter.prototype;
  RelationFilter.prototype.createInput = function (wrapingEl) {
    var entities, projects;

    this.setMultiselectOptions(
      window.urlPrefix +
        "/easy_autocompletes/query_entities" +
        "?" +
        $.param({ autocomplete_options: { entity: this.filters.options.queryEntity } })
    );
    this.multiselect_options["multiple"] = false;
    this.multiselect_options["preload"] = false;
    this.multiselect_options["rootElement"] = "entities";
    entities = this.createAutocomplete(wrapingEl);
    entities.attr("id", entities.attr("id") + "_entities").addClass("input_for_filter");

    this.setMultiselectOptions(window.urlPrefix + "/easy_autocompletes/visible_projects.json");
    this.multiselect_options["multiple"] = false;
    this.multiselect_options["preload"] = false;
    this.multiselect_options["rootElement"] = "projects";
    projects = this.createAutocomplete(wrapingEl);
    projects.attr("id", projects.attr("id") + "_projects").addClass("input_for_filter");

    entities.on("change", function () {
      projects.val("");
    });
    projects.on("change", function () {
      entities.val("");
    });

    this.entities = entities;
    this.projects = projects;
  };
  RelationFilter.prototype.toggle_operator = function (operator) {
    this.parent.toggle_operator.call(this, operator);
    if (operator == "=" || operator == "!") {
      this.input = this.entities;
    } else {
      this.input = this.projects;
    }
  };

  function DateFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  DateFilter.prototype = new Filter();
  DateFilter.prototype.constructor = DateFilter;
  DateFilter.prototype.parent = Filter.prototype;
  DateFilter.prototype.createInput = function (wrapingEl) {
    this.inputSize = 3;
    this.parent.createInput.call(this, wrapingEl);
    wrapingEl.append(document.createTextNode(this.filters.options.i18n.label_day_plural));
  };

  function StringFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  StringFilter.prototype = new Filter();
  StringFilter.prototype.constructor = StringFilter;
  StringFilter.prototype.parent = Filter.prototype;
  StringFilter.prototype.createInput = function (wrapingEl) {
    this.inputSize = 30;
    this.parent.createInput.call(this, wrapingEl);
  };

  class QueryStringFilter extends Filter {
    // QueryString is not regular filter
    // This prevents against using it in a code which dont know how
    isActive() {
      return false;
    }

    /**
     * The value submitted with the form lives in a hidden input (so the legacy filter
     * plumbing keeps working); the interactive editor is the query language micro app
     * mounted into a wrapper, mirroring its text into that hidden input through `onChange`.
     */
    createInput(wrapingEl) {
      this.input = this.create_text_input(this.name);
      this.editor = this.createEditor();

      wrapingEl.append(this.input);
      wrapingEl.append(this.editor);
    }

    createEditor() {
      const editor = document.createElement("div");

      editor.id = `${this.wrapId("values_")}_editor`;
      editor.setAttribute("data-cy", `editor__${this.wrapId("values_")}--query-filters`);

      return editor;
    }

    initEditor() {
      const options = this.filters.options.queryLanguage || {};

      return window.EasyQueryLanguageEditor.init(this.editor.id, {
        queryType: options.queryType || "",
        projectId: options.projectId ?? null,
        placeholder: options.placeholder,
        query: options.query,
        onChange: text => this.onEditorChange(text),
        onApply: this.applyControl() ? () => this.applyControl()?.click() : undefined,
      });
    }

    // The host's apply control, as the heading editor finds it; a form without one (a widget that saves
    // its settings instead) gets an editor without Enter-to-apply.
    applyControl() {
      return document.querySelector(`#${this.filters.options.modulUniqId}filter_buttons [data-easy-query-apply]`);
    }

    onEditorChange(text) {
      if (this.input.val() !== text) this.input.val(text).trigger("change");
    }

    setValue(values) {
      const value = (Array.isArray(values) ? values[0] : values) ?? "";

      this.input.val(value);
      this.handle?.setValue(value);
    }

    createFilter(selected) {
      super.createFilter(selected);
      // The initial values went only into the hidden input above; the editor starts from the token view.
      const handle = this.initEditor();
      this.handle = handle;
      $(this.editor).one("remove", () => void handle.destroy());

      const input = this.input[0];
      this.check_box[0].addEventListener("change", event => {
        input.disabled = !event.target.checked;
        this.handle.setDisabled(!event.target.checked);
      });
    }

    create_text_input(name) {
      if (this.filters.options.blockName) {
        name = `${this.filters.options.blockName}[${name}]`;
      }

      // Class {Filter} counts with a jQuery
      const $input = $("<input>", {
        type: "hidden",
        name: name,
        id: this.wrapId("values_"),
        class: this.wrapClass("values") + " block serialize",
      });

      return $input;
    }
  }

  function IntegerFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  IntegerFilter.prototype = new Filter();
  IntegerFilter.prototype.constructor = IntegerFilter;
  IntegerFilter.prototype.parent = Filter.prototype;
  IntegerFilter.prototype.createInput = function (wrapingEl) {
    var $second = wrapingEl.clone();
    wrapingEl.after($second);

    this.input = [];
    this.input.push(this.create_text_input(this.name, 6));
    this.input.push(this.create_text_input(this.name, 6));

    this.input[0].attr("id", this.input[0].attr("id") + "_1");
    this.input[1].attr("id", this.input[1].attr("id") + "_2");
    wrapingEl.append(this.input[0]);
    $second.append(this.input[1]);
  };
  IntegerFilter.prototype.setValue = function (values) {
    this.input[0].val(values[0]);
    this.input[1].val(values[1]);
  };
  IntegerFilter.prototype.getValue = function () {
    return [this.input[0].val(), this.input[1].val()];
  };

  function TimeFilter(filters, name, type, label) {
    this.filters = filters;
    this.name = name;
    this.type = type;
    this.label = label;
  }
  TimeFilter.prototype = new Filter();
  TimeFilter.prototype.constructor = TimeFilter;
  TimeFilter.prototype.parent = Filter.prototype;
  TimeFilter.prototype.createInput = function (wrapingEl) {
    wrapingEl[0].parentElement.classList.add("query-filter__cell-time-pickers");

    var $second = wrapingEl.clone();
    wrapingEl.after($second);

    this.input = [];
    this.input.push(this.create_time_input(this.name, 6));
    this.input.push(this.create_time_input(this.name, 6));

    this.input[0].attr("id", this.input[0].attr("id") + "_1");
    this.input[1].attr("id", this.input[1].attr("id") + "_2");
    wrapingEl.append(this.input[0]);
    $second.append(this.input[1]);
  };
  TimeFilter.prototype.setValue = function (values) {
    this.input[0].val(values[0]);
    this.input[1].val(values[1]);
  };
  TimeFilter.prototype.getValue = function () {
    return [this.input[0].val(), this.input[1].val()];
  };

  // TODO: easy_lookup, relation

  // ### HELPER FOR VALUES LOADING ###
  function PossibleValuesLoader(filters) {
    this.filters = filters;
    this.batchLoad = false;
  }

  PossibleValuesLoader.prototype.getValues = function (filter_name, callback) {
    var values = this.filters.options.listValues;
    if (values && Object.prototype.hasOwnProperty.call(values, filter_name)) {
      callback(values[filter_name]);
      return;
    }
    if (this.batchLoad) {
      this.filters_to_load.push(filter_name);
      this.callbacks[filter_name] = callback;
    } else {
      this.load(filter_name, callback);
    }
  };

  PossibleValuesLoader.prototype.load = function (filter_names, callback) {
    $.ajax(this.filters.options.listValuesUrl, {
      method: "POST",
      data: $.extend(JSON.parse(this.filters.options.listValuesParams), { filter_name: filter_names, format: "json" }),
      dataType: "json",
      success: callback,
    });
  };

  PossibleValuesLoader.prototype.startBatchLoad = function () {
    this.filters_to_load = [];
    this.callbacks = {};
    this.batchLoad = true;
  };

  PossibleValuesLoader.prototype.loadBatch = function () {
    var that = this;
    if (this.filters_to_load.length > 0) {
      this.load(this.filters_to_load, function (json) {
        var filter;
        for (var i = 0; i < that.filters_to_load.length; ++i) {
          filter = that.filters_to_load[i];
          if (that.callbacks[filter] !== undefined) {
            that.callbacks[filter].call(that.filters, json[filter]);
          }
        }
      });
    }
    this.batchLoad = false;
  };

  // ----------------- WIDGET ------------------

  $.widget("easyquery.filters", {
    options: {
      blockName: null,
      modulUniqId: null,
      queryEntity: null,
      filter_groups: [],
      listMultiple: true,
      loadListValuesImmediately: true,
      selectListFirstValue: true,
      listValuesUrl: null, // url to fetch select/multiselect values from
      listValuesParams: null,
      listValues: null, // optional server-rendered values, keyed by filter name
      availableFilters: null, // available filters and types of them.
      filters: null, // selected filters and their values
      availableOperators: null,
    },
    filter_type_classes: {
      boolean: BooleanFilter,
      list: ListFilter,
      list_optional: ListFilter,
      list_optional_and: ListFilter,
      list_status: ListFilter,
      list_subprojects: ListFilter,
      list_version: ListFilter,
      list_autocomplete: AutocompleteFilter,
      relation: RelationFilter,
      date: DateFilter,
      date_past: DateFilter,
      string: StringFilter,
      text: StringFilter,
      integer: IntegerFilter,
      float: IntegerFilter,
      currency: IntegerFilter,
      date_period: DatePeriodFilter,
      country_select: ListFilter,
      tree: AutocompleteFilter,
      time: TimeFilter,
      query_string: QueryStringFilter,
    },

    _create: function () {
      var that = this;

      this.available_operators = this.options.availableOperators
        ? this.options.availableOperators
        : this.available_operators;

      this.addSelect = $(".add-filter input", this.element);
      this.addSelect.on("change", function (evt) {
        let filterName = $(this).val();
        let autocompleteId = `${$(this).prop("id")}_autocomplete`;
        $(`#${autocompleteId}`).val("");
        if (that.filters[filterName]) return;

        that.addFilter(filterName);
      });
    },

    _init: function () {
      this.valuesLoader = new PossibleValuesLoader(this);
      this.valuesLoader.startBatchLoad();
      this.filters = {};
      this.filters_table = $("#" + this.options.modulUniqId + "filters-table", this.element);
      for (var key in this.options.filters) {
        this.addFilter(key, this.options.filters[key]);
      }
      this.valuesLoader.loadBatch();
    },

    loadPossibleValues: function (filter, callback) {
      this.valuesLoader.getValues(filter, callback);
    },

    addFilter: function (name, selected) {
      var filter = this.options.availableFilters[name];
      if (filter !== undefined) {
        this.filters[name] = new this.filter_type_classes[filter.type](this, name, filter.type, filter.label);
        this.filters[name].createFilter(selected);
      }
    },

    getValues: function () {
      var values = {};
      for (var f in this.filters) {
        if (this.filters[f].isActive()) values[f] = this.filters[f].getUrlValue();
      }
      return values;
    },

    getFiltersTable: function (name) {
      for (var i = this.options.filter_groups.length - 1; i >= 0; --i) {
        var g = this.options.filter_groups[i];
        if (name.substring(0, g.length) === g) {
          return $("#" + this.options.modulUniqId + g + "filters-table", this.element);
        }
      }

      return this.filters_table;
    },
  });
})(jQuery);

// GROUPACE
(function ($, undefined) {
  var plugin = "easygrouploader";
  var defaults = {
    next_button_cols: 1,
    load_opened: false,
    load_limit: 25,
    texts: {
      next: window.I18n.nextButton,
    },
  };

  $.fn[plugin] = function (options, methodParams) {
    $.each($(this), function (idx) {
      var instance = $(this).data("plugin_" + plugin);
      if (!instance) {
        instance = new EasyGroupLoader(this, options);
        $(this).data("plugin_" + plugin, instance);
      } else if (typeof options === "string") {
        switch (options) {
          case "load_groups":
            if (instance.options.load_opened) instance.load_all_groups();
        }
      }
    });
    return $(this);
  };

  function EasyGroupLoader(elem, options) {
    this.groupsContainer = $(elem);
    this.options = $.extend({}, defaults, options);
    this.loadUrl = options.loadUrl || elem.data("url");
    this.texts = this.options.texts;
    this.callback = options.callback;

    this.init();
  }

  EasyGroupLoader.prototype.init = function () {
    var self = this;
    this.groupsContainer.on("click", ".group .expander", function (evt) {
      var $row = $(this).closest("tr.group");
      var group = $row.data("group") || new Group(self, $row);

      if (!group.loaded) {
        if (!group.header.hasClass("group-loaded")) {
          group.load();
          group.toggle();
        }
      } else {
        group.toggle();
        if (typeof self.callback === "function") self.callback();
      }

      this.setAttribute("aria-expanded", `${this.getAttribute("aria-expanded") !== "true"}`);

      affix.recalculateHeads($row.closest("table").find("thead"));

      $row.trigger("EasyGroup--opened");

      //var tablesaw = $row.closest('table').tablesaw().data('tablesaw');
    });
    if (this.options.load_opened) this.load_all_groups();
  };

  EasyGroupLoader.prototype.initInlineEdit = function () {
    $(".multieditable-container:not(.multieditable-initialized)", this.groupsContainer).each(function () {
      initInlineEditForContainer(this);
    });
    EASY.utils.initProjectEdit();
    initEasyAutocomplete();
    LazyLoader.refresh();
  };

  EasyGroupLoader.prototype.load_all_groups = function () {
    var group;
    var self = this;
    var groups_to_load = [];
    var entity_count = 0;
    $(".group", this.groupsContainer)
      .not(".group-loaded")
      .each(function () {
        group = $(this).data("group") || new Group(self, $(this));
        if (!group.loaded) {
          groups_to_load.push(group);
          entity_count += group.count;
        }
        if (entity_count >= self.options.load_limit) {
          self.load_groups(groups_to_load);
          entity_count = 0;
          groups_to_load = [];
        }
      });
    if (groups_to_load.length > 0) {
      this.load_groups(groups_to_load);
    }
  };

  EasyGroupLoader.prototype.load_groups = function (groups_to_load) {
    var self = this;
    var group_names = groups_to_load.map(function (group) {
      return group.group_value;
    });
    // var url = EPExtensions.setAttrToUrl(, 'group_to_load', group_names);
    $.ajax(this.loadUrl, {
      method: "GET",
      data: { group_to_load: group_names },
      success: function (data, textStatus, request) {
        var parsed = typeof data === "object" ? data : $.parseJSON(data);

        $.each(groups_to_load, function (idx, group) {
          group.parseData(parsed[group.group_name]);
          group.toggle();
        });
        self.initInlineEdit();
        if (typeof self.callback === "function") self.callback();
      },
    });
  };

  function Group(loader, header) {
    this.loader = loader;
    this.header = header;
    this.header.data("group", this);
    this.group_name = this.header.data("group-name");
    this.group_value = this.group_name;
    if ($.isArray(this.group_name)) {
      // potencialne nebezpecne - TODO: vymyslet spravny oddelovac
      this.group_name = '["' + this.group_name.join('", "') + '"]';
    }
    this.count = parseInt(this.header.data("entity-count"));
    this.pages = this.header.data("pages") || 1;
    this.loaded = this.header.hasClass("preloaded");
  }

  Group.prototype.toggle = function () {
    EPExtensions.issuesToggleRowGroup(this.header);
  };

  Group.prototype.load = function () {
    var $hrow = this.header;
    var self = this;

    if (!$hrow.hasClass("group-loaded")) {
      $hrow.addClass("group-loaded");
      $.ajax(this.loader.loadUrl, {
        method: "GET",
        data: {
          group_to_load: this.group_value,
        },
        success: function (data, textStatus, request) {
          self.parseData(data);
          self.loader.initInlineEdit();
          if (typeof self.loader.callback === "function") self.loader.callback();
          $hrow.trigger("EasyGroup--loaded");
        },
      });
    }
  };

  Group.prototype.parseData = function (data) {
    var $hrow = this.header;

    this.rows = $(data);
    $hrow.after(this.rows);
    $hrow.data("group-page", 1);
    this.loaded = true;
    if (this.pages > 1) {
      this.createNextButton();
      // .find doesn't work on this set
      this.rows.filter("tr:last").after(this.next_button);
    }
  };

  Group.prototype.loadNext = function () {
    var $hrow = this.header;
    var page = $hrow.data("group-page") + 1;
    var self = this;

    if (page <= this.pages) {
      $.ajax(this.loader.loadUrl, {
        method: "GET",
        data: {
          page: page,
          group_to_load: this.group_value,
        },
        success: function (data, textStatus, request) {
          self.next_button.before(data);

          self.loader.initInlineEdit();
          if (typeof self.loader.callback === "function") self.loader.callback();
          $hrow.data("group-page", page);
          if (self.pages === page) {
            self.next_button.remove();
          }
        },
      });
    }
  };

  Group.prototype.createNextButton = function () {
    //var next_link_url = EPExtensions.setAttrToUrl(this.loader.loadUrl, 'group_to_load', this.group_value);
    var next_link_url =
      this.loader.loadUrl +
      (this.loader.loadUrl.indexOf("?") >= 0 ? "&" : "?") +
      $.param({ group_to_load: this.group_value });
    this.next_link = $("<a>", { href: next_link_url, class: "button" })
      .text(this.loader.texts["next"])
      .append($("<i>", { class: "icon icon-arrow" }));
    this.next_button = $("<tr/>", { class: "easy-next-button" }).html(
      $("<td>", { colspan: this.loader.options.next_button_cols, class: "text-center" }).html(this.next_link)
    );

    var self = this;

    this.next_link.click(function (evt) {
      evt.preventDefault();
      self.loadNext();
    });
  };
})(jQuery);
